import { IconPlusOutline } from '@icons/IconPlusOutline'
import { Button } from '@/components/shadcn/button'
import { useState } from 'react'
import { motion } from 'motion/react'
import { CreateThreadForm } from './CreateThreadForm'
import { SearchInput } from '../../../shared/SearchInput'

export function Actions({
  searchString,
  setSearchString,
  channelId,
  threadKey,
  channelKey,
}: {
  searchString: string
  setSearchString: (value: string) => void
  channelId?: number
  threadKey: string
  channelKey: string
}) {
  const [isCreating, setIsCreating] = useState(false)

  const onCreateThread = () => {
    setSearchString('')
    setIsCreating(true)
  }

  return (
    <motion.div layout className="sticky top-0 flex justify-end gap-2 rounded-xl bg-transparent p-5 backdrop-blur">
      {isCreating ? (
        <CreateThreadForm
          closeForm={() => setIsCreating(false)}
          channelId={channelId}
          threadKey={threadKey}
          channelKey={channelKey}
        />
      ) : (
        <>
          <SearchInput
            placeholder="Search (Description | Creator | Assignee)"
            className="w-80 animate-fade-in-delayed"
            value={searchString}
            onChange={setSearchString}
          />
          <Button size="lg" className="animate-fade-in-delayed" onClick={onCreateThread}>
            <IconPlusOutline />
            <span className="ml-1">New thread</span>
          </Button>
        </>
      )}
    </motion.div>
  )
}
